export const statusString = {
  initial: "initial",
  loading: "loading",
  resolved: "resolved",
  allow: "allow",
  deny: "deny",
};
